import config from '@/config'
import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}api/ticket/v3/cms/analytic`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const surveyApi = {
  getSurvey: (request) => {
    // page_id:212669041930795
    // channel:all // all | facebook | line
    // limit:25
    // offset:0
    // agent:
    // ticket_id:
    // survey_sent_from: // YYYY-MM-DD
    // survey_sent_to: // YYYY-MM-DD
    // survey_submit_from: // YYYY-MM-DD
    // survey_submit_to: // YYYY-MM-DD
    const { params } = request
    return instance().get(`/survey`, {
      params
    })
  }
}

export default surveyApi



// WEBPACK FOOTER //
// ./src/api/survey/survey.js